// extracted by mini-css-extract-plugin
module.exports = {"license":"_93444fe79c--license--1lC4i","license-link":"_93444fe79c--license-link--msDn3"};